import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import Image1 from "../Assets/urbania/Force-Urbania-01.jpg"
import Image2 from "../Assets/WhatsApp Image 2025-12-31 at 2.40.48 PM.jpeg"
import Image3 from "../Assets/WhatsApp Image 2025-12-31 at 2.40.47 PM (1).jpeg"
import Image4 from "../Assets/urbania/urbania.jpg"
import Image5 from "../Assets/urbania/world-class-style-2.jpg"

const VehicleGallery = () => {
  const [likedImages, setLikedImages] = useState(new Set());
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    {
      id: 1,
      url: Image3,
      span: "large" // Main large image
    },
    {
      id: 2,
      url: Image2
    },
    {
      id: 3,
      url: Image1
    },
    {
      id: 4,
      url: Image4
    },
    {
      id: 5,
      url: Image5
    }
  ];

  const toggleLike = (id) => {
    setLikedImages(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 md:mb-10 text-center">
          Force Urbania on Rent in Bangalore
        </h1>
        
        {/* Desktop Grid Layout */}
        <div className="hidden md:grid md:grid-cols-3 md:grid-rows-2 gap-4 h-[600px]">
          {/* Large Image - Takes up left side (2 rows) */}
          <div className="relative col-span-2 row-span-2 rounded-lg overflow-hidden group">
            <img
              src={images[0].url}
              alt="Force Urbania Main"
              className="w-full h-full object-cover"
            />
            <button
              onClick={() => toggleLike(images[0].id)}
              className="absolute top-4 left-4 bg-red-600 rounded-full p-3 hover:bg-red-700 transition-colors z-10"
            >
              <Heart
                className={`w-6 h-6 text-white ${
                  likedImages.has(images[0].id) ? 'fill-white' : ''
                }`}
              />
            </button>
          </div>

          {/* Top Right Images */}
          {images.slice(1, 3).map((image, idx) => (
            <div
              key={image.id}
              className="relative rounded-lg overflow-hidden group"
            >
              <img
                src={image.url}
                alt={`Force Urbania ${idx + 2}`}
                className="w-full h-full object-cover"
              />
              <button
                onClick={() => toggleLike(image.id)}
                className="absolute top-4 left-4 bg-white bg-opacity-80 rounded-full p-2 hover:bg-opacity-100 transition-all"
              >
                <Heart
                  className={`w-5 h-5 ${
                    likedImages.has(image.id)
                      ? 'fill-red-600 text-red-600'
                      : 'text-gray-600'
                  }`}
                />
              </button>
            </div>
          ))}

          {/* Bottom Right Images */}
          {images.slice(3, 5).map((image, idx) => (
            <div
              key={image.id}
              className="relative rounded-lg overflow-hidden group"
            >
              <img
                src={image.url}
                alt={`Force Urbania ${idx + 4}`}
                className="w-full h-full object-cover"
              />
              <button
                onClick={() => toggleLike(image.id)}
                className="absolute top-4 left-4 bg-white bg-opacity-80 rounded-full p-2 hover:bg-opacity-100 transition-all"
              >
                <Heart
                  className={`w-5 h-5 ${
                    likedImages.has(image.id)
                      ? 'fill-red-600 text-red-600'
                      : 'text-gray-600'
                  }`}
                />
              </button>
            </div>
          ))}
        </div>

        {/* Mobile Layout - Slider instead of horizontal scroll */}
        <div className="md:hidden">
          {/* Main Image Slider */}
          <div className="relative rounded-lg overflow-hidden mb-4" style={{ height: '500px' }}>
            <img
              src={images[currentSlide].url}
              alt={`Force Urbania ${currentSlide + 1}`}
              className="w-full h-full object-cover"
            />
            
            {/* Like Button */}
            <button
              onClick={() => toggleLike(images[currentSlide].id)}
              className="absolute top-4 left-4 bg-red-600 rounded-full p-3 hover:bg-red-700 transition-colors z-10"
            >
              <Heart
                className={`w-6 h-6 text-white ${
                  likedImages.has(images[currentSlide].id) ? 'fill-white' : ''
                }`}
              />
            </button>
            
            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur rounded-full w-10 h-10 flex items-center justify-center hover:bg-white shadow-lg"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur rounded-full w-10 h-10 flex items-center justify-center hover:bg-white shadow-lg"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
            
            {/* Dots Indicator */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    currentSlide === index 
                      ? 'bg-white w-6' 
                      : 'bg-white/50'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Thumbnail Grid Below Slider */}
          <div className="grid grid-cols-4 gap-2">
            {images.map((image, index) => (
              <button
                key={image.id}
                onClick={() => setCurrentSlide(index)}
                className={`relative rounded overflow-hidden aspect-square ${
                  currentSlide === index ? 'ring-2 ring-blue-500 ring-offset-2' : ''
                }`}
              >
                <img
                  src={image.url}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                />
                {/* Small Like Indicator on Thumbnails */}
                {likedImages.has(image.id) && (
                  <div className="absolute top-1 right-1 bg-red-600 rounded-full p-1">
                    <Heart className="w-3 h-3 text-white fill-white" />
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleGallery;